import { useFPRegionalDistributionData } from '../../../hooks/useFPRegionalDistributionData';
import { useFPEmergingRegionsData } from '../../../hooks/useFPEmergingRegionsData';
import { useFPUnmetDemandData } from '../../../hooks/useFPUnmetDemandData';
import { ChartSkeleton } from '../shared/AnalyticsSkeletons';
import { SectionError } from './FinancialPartnersSections';
import { RegionalDistributionChart } from './overview/RegionalDistributionChart';
import { EmergingRegionsTable } from './overview/EmergingRegionsTable';
import { UnmetDemandCards } from './overview/UnmetDemandCards';

export const RegionalDistributionSection = ({
  regional,
}: {
  regional: ReturnType<typeof useFPRegionalDistributionData>;
}) => {
  if (regional.isLoading) return <ChartSkeleton />;
  if (regional.isError)
    return (
      <SectionError
        message="Failed to load regional distribution."
        onRetry={() => regional.refetch()}
      />
    );
  if (!regional.data) return null;
  return <RegionalDistributionChart states={regional.data.states} series={regional.data.series} />;
};

export const EmergingRegionsSection = ({
  emerging,
}: {
  emerging: ReturnType<typeof useFPEmergingRegionsData>;
}) => {
  if (emerging.isLoading) return <ChartSkeleton />;
  if (emerging.isError)
    return (
      <SectionError message="Failed to load emerging regions." onRetry={() => emerging.refetch()} />
    );
  if (!emerging.data) return null;
  return <EmergingRegionsTable regions={emerging.data.regions} minVolume={emerging.data.minVolume} />;
};

export const UnmetDemandSection = ({
  unmetDemand,
}: {
  unmetDemand: ReturnType<typeof useFPUnmetDemandData>;
}) => {
  if (unmetDemand.isLoading) return <ChartSkeleton />;
  if (unmetDemand.isError)
    return (
      <SectionError message="Failed to load unmet demand." onRetry={() => unmetDemand.refetch()} />
    );
  if (!unmetDemand.data) return null;
  return <UnmetDemandCards regions={unmetDemand.data.regions} />;
};
